const removeExtraWhitespace = (text?: string | null): string => text?.trim().replace(/\s+/g, ' ') || '';

export { removeExtraWhitespace };
